import React from 'react';
import MissionIcon from './MissionIcon';
import { Trans } from '@ui/i18n/trans';

interface CardInterface {
    title: React.ReactNode;
    desc: React.ReactNode;
}

export default function Vision() {
    return (
        <div className='py-80 px-10 lg:px-80'>
            <div className='w-full flex flex-wrap gap-y-80'>
                <div className="w-full lg:w-1/2 lg:pr-80 text-center lg:text-left">
                    <h2 className='text-black dark:text-white font-semibold text-5xl md:text-[56px]'>
                        <Trans message="Our " />
                        <span className='text-gradient-pink'><Trans message="Vision" /></span>
                    </h2>
                    <p className='text-[#888888] text-lg mt-8'>
                        <Trans message="At Candy Cloudy, our vision is to redefine data management by combining effortless innovation with next-level security and limitless accessibility. We imagine a future where intuitive, seamless navigation empowers you to access, manage, and collaborate on your files with ease—anytime, anywhere, and on any device. Backed by robust security measures like 256-bit encryption and regular backups, we are committed to protecting your data while inspiring a new era of productivity and creativity." />
                    </p>
                </div>
                <div className="w-full lg:w-1/2 flex flex-col gap-80">
                    <VisionCard
                        title={<Trans message="Effortless Innovation" />}
                        desc={<Trans message="We envision a future where managing your data is so intuitive that every interaction feels natural—allowing you to focus on your ideas rather than the tools." />}
                    />
                    <VisionCard
                        title={<Trans message="Next-Level Security" />}
                        desc={<Trans message="Imagine a world where your files are safeguarded by cutting-edge security measures, ensuring peace of mind with advanced encryption and continuous protection against emerging threats." />}
                    />
                    <VisionCard
                        title={<Trans message="Limitless Accessibility" />}
                        desc={<Trans message="Our vision is to create a platform where your files are always at your fingertips—accessible anytime, anywhere, and on any device, empowering you to stay connected and productive wherever life takes you." />}
                    />
                </div>
            </div>
        </div>

    );
}

function VisionCard({ desc, title }: CardInterface) {
    return (
        <div className='flex items-start gap-32'>
            <div className='bg-[#EC008C1A] w-80 min-w-80 h-80 rounded-full flex items-center justify-center'><MissionIcon /></div>
            <div>
                <h3 className='text-[#333333] dark:text-gray-300 text-2xl font-semibold mb-16'>{title}</h3>
                <p className='text-[#888888] font-light'>{desc}</p>
            </div>
        </div>
    );
}
